import { render } from "./ParseyIcon.vue?vue&type=template&id=283ed653"
import script from "./ParseyIcon.vue?vue&type=script&lang=js"
export * from "./ParseyIcon.vue?vue&type=script&lang=js"
script.render = render

export default script